export default __webpack_public_path__ + "static/body-bg-5a5f7c9f9b8b756685dec5dc8f523038.png";